import React from "react"
import { connect } from "react-redux"

const DragAndDropToggle = ({ eventsSortOptions }) => {
  return (
    <span
      className={`drag-drop-button ${
        eventsSortOptions.o === "order" ? "" : "disabled"
      }`}
    >
      <i
        className="bx bx-sm bx-menu"
        style={eventsSortOptions.o === "order" ? {} : { color: "#B1B0B0" }}
      ></i>
    </span>
  )
}

const mapStateToProps = state => ({
  eventsSortOptions: state.experiences.eventsSortOptions,
})

export default connect(mapStateToProps)(DragAndDropToggle)
